import apiService from 'services/api'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import annotationPlugin from 'chartjs-plugin-annotation'
import { Chart } from 'chart.js'
import 'react-toggle/style.css'
import { SalesPipelineChart } from '../../../components/Charts/SalesPipelineChart'
import { DealsPipelineTable } from 'components/Tables/DealsPipelineTable/DealsPipelineTable'
import { Block } from 'components/UI/Block'
import { FBPage } from 'components/FbUI/Page/FBPage'
import { InfoCard } from 'components/UI/InfoCard'
import { SalesForecast } from 'components/Dashboard/SalesForecast'
import { featureFlagService } from 'utils/featureFlagService'
import WarningBanner from 'components/Banners/WarningBanner'
import { NewFooter } from 'components/Layout/Footer/NewFooter'
import { useHideFooter } from 'context/layout'

Chart.register(ChartDataLabels)
Chart.register(annotationPlugin)

export function Dashboard() {
  const api = apiService()
  const { enabledReportDeals } = featureFlagService()
  const { data: overview } = api.useGetDashboardOverview(enabledReportDeals)

  // Hide global footer and show it inside content area so it scrolls with content
  useHideFooter()

  return (
    <FBPage className="gap-y-4" noContainer innerPageClassName="!pb-0">
      <div className="flex flex-col min-h-full">
        {!enabledReportDeals && (
          <div className="mb-3">
            <WarningBanner text="Our system is down for maintenance. Revenue calculations may be delayed to load or update." />
          </div>
        )}
        <Block className={'mb-3'}>
          <h3 className="text-4xl text-slate-900 font-bold mb-8">
            Deals Dashboard
          </h3>
          <div className="flex flex-row flex-wrap gap-4">
            {Object.entries(overview || {}).map(([k, v]) => (
              <InfoCard
                key={k}
                title={v.title}
                value={v.value}
                tooltip={v.tooltip}
              />
            ))}
          </div>
        </Block>

        <Block className={'mb-3'}>
          <SalesForecast />
        </Block>

        <Block className={'mb-3'}>
          <SalesPipelineChart />
        </Block>

        <Block className={'mb-3'}>
          <DealsPipelineTable
            tableKey={'dashboard-table'}
            tableTypeSlug={'deals-pipeline-table'}
          />
        </Block>

        <div className="mt-auto">
          <NewFooter />
        </div>
      </div>
    </FBPage>
  )
}
